import { Response } from "@/models/shared/Response";
import { IdentifierAssociationRequest } from "@/models/shared/IdentifierAssociationRequest";
import { IdentifierAssociationResponse } from "@/models/shared/IdentifierAssociationResponse";

export interface IIdentifierAssociationService {
  associate(
    identifierlAssociation: IdentifierAssociationRequest<string>,
    identifierAssociationUrl: string
  ): Promise<Response<IdentifierAssociationResponse>>;
}

export class IdentifierAssociationService implements IIdentifierAssociationService {
  async associate(
    identifierlAssociation: IdentifierAssociationRequest<string>,
    identifierAssociationUrl: string
  ): Promise<Response<IdentifierAssociationResponse>> {
    const resp = await fetch(identifierAssociationUrl, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(identifierlAssociation),
    });

    if (resp.ok) {
      return { kind: "success", value: await resp.json() };
    } else if (resp.status === 400) {
      const error = await resp.json();

      const returnedError = error.find((c: any) => c.Code != null);
      return {
        kind: "error",
        code: returnedError.Code ? returnedError.Code : 0,
        message: returnedError.message ? returnedError.message : "",
      };
    } else {
      return {
        kind: "unexpected_error",
      };
    }
  }
}

export const identifierAssociationService = new IdentifierAssociationService();
